import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/buffet/store/mutations";
import { getters } from "@/components/buffet/store/getters";
import { actions } from "@/components/buffet/store/actions";
import { BuffetState } from "@/components/buffet/types";

export const state: BuffetState = {
  updatedBuffetItems: false,
  playedEpgItemId: undefined,
  playedEpgItemPos: undefined,
  playedEpgItemCat: undefined,
  playedEpgItemDate: ""
};

export const buffet: Module<BuffetState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
